import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.DEPOSIT);

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const depositService = {
  // Tạo yêu cầu nạp tiền
  createDeposit: async (depositData) => {
    try {
      const response = await axios.post(API_URL, depositData, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể tạo yêu cầu nạp tiền'));
    }
  },

  // 发起 USDT-TRC20 链上充值：拿收款地址 + 精确支付金额
  startPayment: async (amount) => {
    try {
      const response = await axios.post(`${API_URL}/start-payment`, { amount }, getAuthHeader());
      return response.data;
    } catch (error) {
      const err = new Error(error.response?.data?.error || translateVi('Không thể tạo yêu cầu nạp tiền'));
      err.errorCode = error.response?.data?.errorCode;
      throw err;
    }
  },

  // 轮询充值到账状态（approved 即已入账）
  getStatus: async (depositId) => {
    try {
      const response = await axios.get(`${API_URL}/${depositId}/status`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể kiểm tra trạng thái nạp tiền'));
    }
  },

  // Lấy lịch sử nạp tiền
  getHistory: async (limit = 50) => {
    try {
      const response = await axios.get(`${API_URL}/history?limit=${limit}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy lịch sử nạp tiền'));
    }
  },

  // Lấy thống kê
  getStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/stats`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy thống kê'));
    }
  }
};
